import 'leaflet/dist/leaflet.css';

import { AdminContainer } from '@/components/containers';
import { ProjectsTable } from '@/components/tables/projects-table.component';
import { cn } from '@/lib/utils';
import { useCustomer } from '@/modules/Customers/Customers.api';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

function ProjectsList() {
  const { customerId } = useParams<{ customerId: string }>();
  const { data, status } = useCustomer(customerId || undefined);

  if (status === 'error') {
    toast.error('Failed to fetch customer information');
    return;
  }
  let title = 'Loading...';

  if (!customerId) {
    title = 'Projects';
  } else if (data?.client_name) {
    title = data.client_name;
  }
  const breadcrumbData = data && {
    client: {
      id: data.client_id,
      name: data.client_name,
    },
  };

  return (
    <IfPermitted permissions={[UserPermissions.PROJECT_LIST]}>
      <AdminContainer className={cn('flex flex-col')} title={title} breadcrumbData={breadcrumbData}>
        <ProjectsTable />
      </AdminContainer>
    </IfPermitted>
  );
}

export default ProjectsList;
